export const getSchoolsArray = (studentArray) => {
  const schools = []
  studentArray.forEach((student) => {
      schools.push(student.studentSchool)
  })
  return schools;
};